
<!-- <button mat-flat-button color="primary" aria-label="back" [routerLink]="'/orders'">
    <mat-icon>back</mat-icon>
    <span>Back</span>
</button> -->
<ng2-pdfjs-viewer [pdfSrc]="src" [print]="true" [startPrint]="true" pagemode="none" zoom ="100" [showSpinner]="true">
</ng2-pdfjs-viewer>